<template>
  <el-dialog :visible.sync="calendarVisible" center :close-on-click-modal="false" width="1100px" append-to-body>
    <div class="table_box">
      <el-button-group class="btnlist">
        <el-button
          size="small"
          v-for="(item, index) in btnList"
          :key="item.index"
          class="btn"
          :class="{ isActive:isChange === index}"
          plain
          @click="tabBtn(index)"
        >{{item.name}}</el-button>
      </el-button-group>
      <!--点击按钮进行切换-->
      <div style="margin-top: 40px">
        <monthCalendar ref="month" v-show="isChange === 0"></monthCalendar>
        <weekCalendar  ref="week" v-show="isChange === 1"></weekCalendar>
      </div>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="margin-top:20px">
      <el-form-item label="预约日期:" prop="appointDate">
        <el-date-picker
          v-model="form.appointDate"
          :picker-options="pickerOptions"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="预约时间段" prop="appointStartTime" >
        <!-- 因为要做半个小时节点，日期时间选择框不支持，改成了分开写 -->
        <el-time-select
          placeholder="开始时间"
          v-model="form.appointStartTime"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:59',
            maxTime: form.appointEndTime
          }"
        ></el-time-select>
        ～ <el-time-select
          placeholder="结束时间"
          v-model="form.appointEndTime"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '23:59',
            minTime: form.appointStartTime
          }"
        ></el-time-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="calendarVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmSubmitForm" v-preventClick>确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import weekCalendar from "./weekCalendar";
import monthCalendar from "./monthCalendar";
import moment from "moment"
import { getAppointmentRecord,appointmentConflict } from "@/api/request";
export default {
  props: {},
  data() {
    var validateTime = (rule, value, callback) => {
      if (!this.form.appointEndTime) {
        return callback(new Error("请选择预约结束时间"));
      }
      let startdate = this.form.appointDate + ' ' + this.form.appointStartTime
      if (moment(startdate).format('YYYY-MM-DD HH:mm') < moment().format('YYYY-MM-DD HH:mm')) {
        return callback(new Error("预约时间不能小于当前时间"));
      }
      callback();
    };
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now()-(24 * 60 * 60 * 1000));
        }
      },
      calendarVisible: false,
      btnList: [{ name: "月" }, { name: "周" }],
      isChange: 1,
      equipmentId: "",
      rules: {
        appointDate: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        appointStartTime: [
          { required: true, message: "请选择预约开始时间", trigger: "change" },
          { validator: validateTime, trigger: "change" }
        ],
      },
      dataform: {
        conflictFlag: false // 预约时间是否冲突
      },
      form: {
        appointDate: '',
        appointStartTime: '',
        appointEndTime: ''
      }
    };
  },
  components: { weekCalendar, monthCalendar },
  methods: {
    init(form) {
      this.calendarVisible = true;
      this.$nextTick(() => {
        this.getList(form.id)
        this.equipmentId = form.id
      });
    },
    getList(id) {
      if (this.isChange == 0) {
        this.$refs.month.getList(id);
      }
      if (this.isChange == 1) {
        this.$refs.week.getWeeks(id);
      }
    },
    confirmSubmitForm() {
      this.$refs["form"].validate(valid => {
        if (valid && !this.dataform.conflictFlag) {
          let startTime = this.form.appointDate + ' ' + this.form.appointStartTime
          let endTime = this.form.appointDate + ' ' + this.form.appointEndTime
          let obj = this.getDateDiff(startTime,endTime,"minute");
          let appointHours = obj.hours + obj.min / 60;
          if (appointHours < 1) {
           return this.$message.warning("预约时间至少1小时");
          }
          appointmentConflict({equipmentId: this.equipmentId,appointmentStartDate: startTime,appointmentEndDate: endTime}).then(res=> {
            this.calendarVisible = false;
            this.$emit("getTime", this.form);
          })
          
        }
      });
    },
    tabBtn(index) {
      this.isChange = index;
      this.getList(this.equipmentId)
    }
  }
};
</script>
<style scoped lang="scss">
.btnlist {
  width: 120px;
  position: absolute;
  background: #fff;
  right: 40px;
  z-index: 2010;
  top: 30px;
}
.isActive {
  background: #ecf5ff !important;
  border-color: #4d6fff !important;
  color: #fff;
}
.btn {
  color: #4d6fff;
  background: #fff;
  border-color: #b3d8ff;
  width: 60px;
}
.table_box {
  background: #fff;
  height: 500px;
  border-radius: 20px;
  overflow: hidden;
  overflow-y: scroll;
  margin-bottom: 40px;
  .form_box {
    // margin-left: 100px;
    margin-top: 30px;
    width: 40%;
    text-align: left;
  }
}
</style>
